module.exports = __webpack_public_path__ + "assets/img/6ac86a1411e933c522709e1434c17988.png";